import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { AccessDeniedComponent } from './access-denied/access-denied.component';
import { BusyComponent } from './components/busy/busy.component';
import { EmptyListStateComponent } from './components/empty-list-state/empty-list-state.component';
import { ErrorMessagesComponent } from './components/error-message/error-messages.component';
import { ExpanderComponent } from './components/expander/expander.component';
import { SearchInputComponent } from './components/search-input/search-input.component';
import { MoveToHeadDirective } from './directives/move-to-head.directive';
import { ServiceUnavailableComponent } from './service-unavailable/service-unavailable.component';

@NgModule({
  declarations: [
    BusyComponent,
    ExpanderComponent,
    EmptyListStateComponent,
    ErrorMessagesComponent,
    MoveToHeadDirective,
    AccessDeniedComponent,
    ServiceUnavailableComponent,
    SearchInputComponent,
  ],
  imports: [CommonModule, ReactiveFormsModule],
  exports: [
    BusyComponent,
    ExpanderComponent,
    EmptyListStateComponent,
    ErrorMessagesComponent,
    MoveToHeadDirective,
    ServiceUnavailableComponent,
    SearchInputComponent,
  ],
})
export class CoreModule {}
